/**
 * TimelinePortal — saca las ventanas del timeline de su capa.
 *
 * `.tl-editor` es `position: fixed; z-index: 60`, así que todo lo que se
 * dibuja adentro compite sólo dentro de ese 60: el dock de LMX (61) quedaba
 * por encima de la galería, los stickers, las plantillas y el modal de
 * conflicto, aunque declararan z-index 80 o 9000. Renderizadas en
 * `document.body` vuelven a valer su z-index real.
 *
 * `.tl-portal` repone lo que antes heredaban de `.tl-editor` (color y tamaño
 * de letra) para que se vean igual que antes.
 */
import { createPortal } from 'react-dom';

export default function TimelinePortal({ children }) {
  if (typeof document === 'undefined') return children;
  return createPortal(<div className="tl-portal">{children}</div>, document.body);
}
